// Implementation lives in slugify-core.js so Node ESM build scripts can
// import it without a TypeScript toolchain. Keep this file as the public
// import surface for the app.
import { slugify } from "./slugify-core.js";

export { slugify };

export function findCompanyBySlug(
  companies: Array<{ Name: string; [key: string]: string }>,
  slug: string,
): { Name: string; [key: string]: string } | undefined {
  return companies.find((c) => slugify(c.Name) === slug);
}
